import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import ParameterFieldBase, { IValidator } from './ParameterFieldBase';
import EditComponent, { IStringFieldOptions } from '../tsx/StringField';
import { validators as Validators } from './validators';

export default class StringField extends ParameterFieldBase<IStringFieldOptions> {
    public static EditComponent = EditComponent;

    public getDefaultOptions() {
        return {};
    }

    constructor(
        glob: IGlob,
        title: string,
        validators?: IValidator[],
        defaultVal: string = 'Some value',
        options?: IStringFieldOptions
    ) {
        super(
            glob,
            title,
            options?.allowNull ? undefined : [Validators.string.shouldBe],
            validators,
            defaultVal,
            options
        );
    }
}
